import api from '../../api/prismic'
import * as actionTypes from '../actionTypes'
import * as mutationTypes from '../mutationTypes'
import slugify from 'slugify'
import PrismicDOM from 'prismic-dom'

const state = {
  colophon: {
    data: {
      text: [
        {
          text: ''
        }
      ]
    }
  },
  about: {
    data: {
      text: ''
    }
  },
  biographies: '',
  works: [],
  single: {
    data: {
      text: [
        {
          text: ''
        }
      ],
      media: '',
      year: ''
    }
  }
}

const actions = {
  async [actionTypes.GET_POSTS]({commit, state}) {
    commit(mutationTypes.SET_POSTS, await api.getPosts())
  },
  [actionTypes.SET_SINGLE]({commit, state}, post) {
    commit(mutationTypes.SET_SINGLE, post)
  }
}

const mutations = {
  [mutationTypes.SET_POSTS](state, data) {
    state.colophon = data.filter(e => e.type === 'colophon')[0]
    state.about = data.filter(e => e.type === 'about')[0]
    state.biographies = PrismicDOM.RichText.asHtml(data.filter(e => e.type === 'biographies')[0].data.text, doc => doc)
    state.works = data.filter(e => e.type === 'work')
    state.works = state.works.map(e => {
      e.data.credits = PrismicDOM.RichText.asHtml(e.data.credits, doc => doc)
      return e
    })
    state.works = state.works.map(e => {
      e.slugs[0] = slugify(e.slugs[0])
      return e
    })
    state.works = state.works.sort((a, b) => {
      if (a.data.order > b.data.order) {
        return 1
      } else if (a.data.order < b.data.order) {
        return -1
      } else {
        return 0
      }
    })
  },
  [mutationTypes.SET_SINGLE](state, post) {
    state.single = post
  }
}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/main.js